export type BookingType = 'free-consultation' | 'paid-session';

export interface BookingConfig {
  type: BookingType;
  duration: number; // in minutes
  price?: number; // in dollars
  title: string;
  description: string;
  stepCount: number;
}

export const BOOKING_CONFIGS: Record<BookingType, BookingConfig> = {
  'free-consultation': {
    type: 'free-consultation',
    duration: 15,
    title: 'Book Your Free 15-min Consultation',
    description: 'Get clarity and guidance — no obligation to continue.',
    stepCount: 2
  },
  'paid-session': {
    type: 'paid-session',
    duration: 30,
    price: 150,
    title: 'Book Your Session',
    description: 'Select your session length and complete payment.',
    stepCount: 3
  }
};
